export class ProximityConstraintTask {
	constructor() {
	}
} 
